import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiRdaInApprovazioneWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'rda-in-approvazione-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/count', {
        params: { stato_nome: 'In attesa approvazione' },
      })
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="RDA in approvazione"
      value={data}
      loading={isLoading}
      color={data ? '#fa8c16' : '#52c41a'}
      onClick={() => navigate('/rda?stato_nome=In%20attesa%20approvazione')}
    />
  )
}
